module.exports = __webpack_public_path__ + "img/F3F7_new.556f737a.jpg";